import { storeToRefs } from 'pinia';
import { defineNuxtRouteMiddleware, navigateTo } from '#app/composables/router';
import { useAuth } from '#layers/access/public';
import { resolveBackdropWorkspaceSlug } from '#layers/workspace/public';

/**
 * Resolves the backdrop workspace for `/` and redirects to it (or the no-workspace page).
 *
 * Resolving the destination here — rather than via `navigateTo` inside the page `setup()` —
 * applies the redirect before the destination mounts, avoiding the re-entrant `router.replace`
 * issued during the initial hydration Suspense that otherwise races the router's own boot
 * navigation and strands the user on `/` (same reasoning as `workspace-landing`).
 */
export default defineNuxtRouteMiddleware(async () => {
	const { currentUser } = storeToRefs(useAuth());
	const slug = await resolveBackdropWorkspaceSlug(currentUser.value?.id);

	return navigateTo(
		slug ? { name: 'workspace-home', params: { workspace: slug } } : { name: 'no-workspace' },
		{ replace: true },
	);
});
